<ng-container *ngIf="data$ | async as data">
  <ng-container *ngIf="data.has_carbon_footprint">
    <span class="ag-label label-success carbon-footprint-badge"
       [popover]="carbonFootprintPopover"
       triggers="mouseenter:mouseleave"
       placement="right"
       container="body"
       containerClass="popFadeDelay">
      <span class="glyphicon glyphicon-leaf" aria-hidden="true"></span> {{ 'CARBON_FOOTPRINT.BADGE'|translate }}
    </span>
  </ng-container>

  <ng-template #carbonFootprintPopover>
    <p class="small">{{ 'CARBON_FOOTPRINT.DESCRIPTION'|translate }}</p>
    <p class="small" *ngIf="data.campaign"><b>{{ 'CARBON_FOOTPRINT.CAMPAIGN'|translate }}:</b> {{ data.campaign.name }}</p>
    <hr class="carbon-footprint-popover-divider">
    <div *ngFor="let species of data.species" class="carbon-footprint-crop-stats">
      <p class="small"><b>{{ species.name | titlecase }}</b></p>
      <p class="small">{{ species.hectares | number:'1.0-0':currentLang }} {{ 'CARBON_FOOTPRINT.HECTARES'|translate }}</p>
      <p class="small">{{ species.tons | number:'1.0-0':currentLang }} {{ 'CARBON_FOOTPRINT.TONS'|translate }}</p>
    </div>
  </ng-template>
</ng-container>
